import React from "react";
import LeftArrowIcon from "../../../components/icons/LeftArrowIcon";
import RightArrowIcon from "../../../components/icons/RightArrowIcon";
import "./PaginationButton.scss";

const PaginationButton = ({
  total_page,
  page_number,
  onClickPreview,
  onClickNext,
  is_loading,
}: {
  total_page: number;
  page_number: number;
  onClickPreview: any;
  onClickNext: any;
  is_loading: boolean;
}) => {
  return (
    <>
      {total_page > 1 && (
        <div className="pagination-button-container">
          <div className="pagination-button-contain">
            <button
              className="preview-box pagination-button"
              onClick={onClickPreview}
              disabled={page_number === 1 || is_loading ? true : false}
            >
              <LeftArrowIcon />
            </button>
            <div className="pagination-page-no">
              <p>
                Page {page_number} of {total_page}
              </p>
            </div>
            <button
              className="next-box pagination-button"
              onClick={onClickNext}
              disabled={page_number === total_page || is_loading ? true : false}
            >
              <RightArrowIcon />
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default PaginationButton;
